<script>
  import { Link } from '@inertiajs/svelte'

  let {
    condition, // boolean - if true, show link; if false, show text
    href,
    ...restProps
  } = $props()
</script>

{#if condition}
  <Link href={href} {...restProps}><slot /></Link>
{:else}
  <span {...restProps}><slot /></span>
{/if}
